import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/veesoai-black.svg")